/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Carrier_Form_Cod_Summary_Breakdown_CompanyInputs */

const vi_carrier_form_cod_summary_breakdown_company = /** @type {(inputs: Carrier_Form_Cod_Summary_Breakdown_CompanyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cước ${i?.fee}đ Hảo Đạt trả`)
};

/**

* @param {Carrier_Form_Cod_Summary_Breakdown_CompanyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_summary_breakdown_company = /** @type {((inputs: Carrier_Form_Cod_Summary_Breakdown_CompanyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_Summary_Breakdown_CompanyInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_summary_breakdown_company(inputs)
});